import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { ISelectField } from '@/ui-kit/table-filters/filters.type';

import { IAllWalletsFiltersFormFields } from '@/features/wallets/store/types/agent-wallets.types';
import { TWalletStatus, walletStatusList } from '@/features/wallets/store/models/wallet.model';

export function mapAllWalletsStatus(value: TWalletStatus) {
  return {
    walletStatus: value,
  };
}

export function useAllWalletsStatusField(methods: UseFormReturn<IAllWalletsFiltersFormFields>, onChange): ISelectField {
  const { t } = useTranslation();

  const handleStatusChange = useCallback(
    (value: IAllWalletsFiltersFormFields['status']) => {
      methods.setValue('status', value);
      onChange();
    },
    [onChange, methods],
  );

  const statusOptions: TOption[] = Object.keys(walletStatusList).map((status: string) => ({
    label: t(`monetics.wallet.status.${status}`),
    value: walletStatusList[status],
  }));
  const statusValue = statusOptions.find((option) => option.value === methods.watch('status'));

  return {
    value: statusValue,
    handleChange: handleStatusChange,
    options: statusOptions,
  };
}
